import PropTypes from 'prop-types';
import { Form, Button, Card, Row, Col, ProgressBar } from 'react-bootstrap';

ReporteHogaresYPersonas.propTypes = {
    datosHogares: PropTypes.object.isRequired,
    datosPersonas: PropTypes.object.isRequired,
};

function ReporteHogaresYPersonas({datosHogares, datosPersonas}) {


    return (
        <Card>
            <Card.Header>
                <h2>Reporte general hogares y personas</h2>
            </Card.Header>
            <Card.Body>
                {datosHogares && <Row>
                    <Col md={6}>
                        <div className="box">
                        <div className="box-header">
                            <h3 className="box-title">HOGARES</h3>
                        </div>
                        <div className="box-body no-padding">
                            <table className="table">
                            <thead>
                                <tr>
                                    <th style={{width: '50%'}}></th>
                                    <th style={{width: '25%'}}></th>
                                    <th>Cantidad</th>
                                    <th style={{width: '40px'}}>Porcentaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td><b>Total número de hogares:</b></td>
                                <td>
                                    <ProgressBar now={100} />
                                </td>
                                <td><Form.Label><span id="rGenNumFam">{datosHogares.total}</span></Form.Label></td>
                                <td><span id="percNumFam" className="badge bg-blue">100%</span></td>
                                </tr>
                                <tr>
                                <td>Total número de hogares solo Víctimas:</td>
                                <td>
                                    <ProgressBar now={datosHogares.victimasPercentage} variant="success" />
                                </td>
                                <td><Form.Label><span id="rGenNumFamVict">{datosHogares.victimas}</span></Form.Label></td>
                                <td><span id="percNumFamVict" className="badge bg-green">{datosHogares.victimasPercentage}%</span></td>
                                </tr>
                                <tr>
                                <td>Total número de hogares Compuestas:</td>
                                <td>
                                    <ProgressBar now={datosHogares.compuestasPercentage} variant="warning" />
                                </td>
                                <td><Form.Label><span id="rGenNumFamComp">{datosHogares.compuestas}</span></Form.Label></td>
                                <td><span id="percNumFamComp" className="badge bg-yellow">{datosHogares.compuestasPercentage}%</span></td>
                                </tr>
                                <tr>
                                <td>Total número de hogares No Víctimas:</td>
                                <td>
                                    <ProgressBar now={datosHogares.noVictimasPercentage} variant="danger" />
                                </td>
                                <td><Form.Label><span id="rGenNumFamNoVict">{datosHogares.noVictimas}</span></Form.Label></td>
                                <td><span id="percNumFamNoVict" className="badge bg-red">{datosHogares.noVictimasPercentage}%</span></td>
                                </tr>      
                            </tbody>  
                            </table>
                        </div>
                        </div>
                    </Col> 
                    <Col md={6} id="canvas-hogares">
                        <canvas id="chart-area-hogares"></canvas>
                    </Col>
                </Row>}
                
                {datosPersonas && <Row>
                    <Col md={6}>
                        <div className="box">
                        <div className="box-header">
                            <h3 className="box-title">PERSONAS</h3>
                        </div>
                        <div className="box-body no-padding">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th style={{width: "50%"}}></th>
                                    <th style={{width: "25%"}}></th>
                                    <th>Cantidad</th>
                                    <th style={{width: "40px"}}>Porcentaje</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td><b>Total número de personas:</b></td>
                                    <td>
                                        <ProgressBar now={datosPersonas.totalPercentage} variant="primary" />
                                    </td>
                                    <td><Form.Label><span id="nPersonas">{datosPersonas.total}</span></Form.Label></td>
                                    <td><span id="nPerPersonas" className="badge bg-blue">{datosPersonas.totalPercentage}%</span></td>
                                    </tr>
                                    <tr>
                                    <td>Total número de personas Víctimas:</td>
                                    <td>
                                        <ProgressBar now={datosPersonas.victimasPercentage} variant="success" />
                                    </td>
                                    <td><Form.Label><span id="nPersVict">{datosPersonas.victimas}</span></Form.Label></td>
                                    <td><span id="nPorPersvict" className="badge bg-green">{datosPersonas.victimasPercentage}%</span></td>
                                    </tr>
                                    <tr>
                                    <td>Total número de personas en Valoración</td>
                                    <td>
                                        <ProgressBar now={datosPersonas.valoracionPercentage} variant="warning" />
                                    </td>
                                    <td><Form.Label><span id="nPersVal">{datosPersonas.valoracion}</span></Form.Label></td>
                                    <td><span id="nPorPersVal" className="badge bg-yellow">{datosPersonas.valoracionPercentage}%</span></td>
                                    </tr>
                                    <tr>
                                    <td>Total número de personas No Incluidas:</td>
                                    <td>
                                        <ProgressBar now={datosPersonas.noIncluidasPercentage} variant="danger" />
                                    </td>
                                    <td><Form.Label><span id="nPersDVictNoSon">{datosPersonas.noIncluidas}</span></Form.Label></td>
                                    <td><span id="nPorPersDVictNoSon" className="badge bg-red">{datosPersonas.noIncluidasPercentage}%</span></td>
                                    </tr>
                                    <tr>
                                    <td>Total número de personas No Víctimas:</td>
                                    <td>
                                        <ProgressBar now={datosPersonas.noVictimasPercentage} variant="danger" />
                                    </td>
                                    <td><Form.Label><span id="nPersNVict">{datosPersonas.noVictimas}</span></Form.Label></td>
                                    <td><span id="nPorPersNvict" className="badge bg-red">{datosPersonas.noVictimasPercentage}%</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <Button type="button" className="btn btn-block btn-primary btn-sm" >Descargar datos</Button>  
                        </div>
                        </div>
                    </Col>
                    <Col md={6} id="canvas-personas">
                        <canvas id="chart-area-personas"></canvas>
                    </Col>
                </Row>}
            </Card.Body>
        </Card>
    );
}

export default ReporteHogaresYPersonas;